import { render, staticRenderFns } from "./Carts.vue?vue&type=template&id=6133ce09&scoped=true&"
import script from "./Carts.vue?vue&type=script&lang=js&"
export * from "./Carts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6133ce09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6133ce09')) {
      api.createRecord('6133ce09', component.options)
    } else {
      api.reload('6133ce09', component.options)
    }
    module.hot.accept("./Carts.vue?vue&type=template&id=6133ce09&scoped=true&", function () {
      api.rerender('6133ce09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Carts.vue"
export default component.exports